import { Toaster as Sonner, toast } from "sonner"
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "group toast pointer-events-auto flex items-start gap-3 w-full max-w-[380px] p-3.5 pr-10 bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 relative",
          title: "text-[13.5px] font-semibold text-gray-900 leading-snug tracking-tight",
          description: "text-[12px] text-gray-500 mt-0.5 leading-snug",
          actionButton:
            "bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg hover:bg-gray-800 transition-colors ml-2",
          cancelButton:
            "bg-gray-100 text-gray-700 text-xs font-medium px-3 py-1.5 rounded-lg hover:bg-gray-200 transition-colors",
          closeButton:
            "!bg-transparent !border-0 !text-gray-400 hover:!text-gray-700 hover:!bg-gray-50 !rounded-full !w-7 !h-7 !absolute !right-1.5 !top-1.5 !flex !items-center !justify-center",
          success: "!border-0 before:content-[''] before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-emerald-500 before:rounded-r-full",
          error: "!border-0 before:content-[''] before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-red-500 before:rounded-r-full",
          warning: "!border-0 before:content-[''] before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-amber-500 before:rounded-r-full",
          info: "!border-0 before:content-[''] before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-blue-500 before:rounded-r-full",
        },
      }}
      icons={{
        success: (
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-emerald-50 flex items-center justify-center">
            <CheckCircle2 className="w-4 h-4 text-emerald-600" strokeWidth={2.5} />
          </div>
        ),
        error: (
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-red-50 flex items-center justify-center">
            <XCircle className="w-4 h-4 text-red-600" strokeWidth={2.5} />
          </div>
        ),
        warning: (
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-amber-50 flex items-center justify-center">
            <AlertTriangle className="w-4 h-4 text-amber-600" strokeWidth={2.5} />
          </div>
        ),
        info: (
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-blue-50 flex items-center justify-center">
            <Info className="w-4 h-4 text-blue-600" strokeWidth={2.5} />
          </div>
        ),
      }}
      {...props} />
  );
}

export { Toaster, toast }
